module.exports = __webpack_public_path__ + "img/logo5.ddd77844.png";